// extracted by mini-css-extract-plugin
export default {"wrapper":"HeroPortada_wrapper__2k8RU"};